// anhang_arbeitsergebnisse — the deliverable register, two columns of blocks (v15 slides
// 18–22): gold 2px rule at the block's left, «DEL-nn · Name» serif 16px, TERMIN mono line,
// the items as mono gold ref + 10.7px title. Placement comes from the bound resolver.
import type { AnhangArbeitsergebnisseContent, AnhangBBound } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Eyebrow, PageNo, fmtDot } from './chrome.js';

const COL_X = [64, 668] as const;
const COL_W = 548;

export default function AnhangArbeitsergebnissePreview({ content, bound, page = 0, pageNo }: {
  content: AnhangArbeitsergebnisseContent;
  bound?: AnhangBBound;
  page?: number;
  pageNo?: number | null;
}) {
  const c = content;
  const pages = bound?.pages ?? [];
  const bp = pages[page];
  const counter = bp && bp.pageCount > 1 ? ` · ${bp.pageNo}/${bp.pageCount}` : '';
  return (
    <Dkp>
      <Eyebrow text={`${c.eyebrow ?? ''}${counter}`} />
      {bp?.title ? (
        <Abs x={64} y={84} w={1000}>
          <div className="dkp-serif" style={{ fontSize: 25.3, lineHeight: 1.2 }}>{bp.title}</div>
        </Abs>
      ) : null}
      {bp ? bp.columns.map((blocks, ci) => blocks.map((b) => {
        const x = COL_X[ci];
        const termin = [b.due ? `TERMIN ${fmtDot(b.due)}` : 'TERMIN OFFEN', b.dueNote.toUpperCase()]
          .filter((p) => p !== '').join(' · ');
        let iy = b.y + 46;
        return (
          <div key={`${ci}-${b.ref}`}>
            <Abs x={x} y={b.y + 2} w={2} h={b.height - 21} style={{ background: '#C8A96E' }} />
            <Abs x={x + 16} y={b.y} w={COL_W - 16}>
              <div className="dkp-serif" style={{ fontSize: 16, lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {b.ref} · {b.name}
              </div>
            </Abs>
            <Abs x={x + 16} y={b.y + 26} w={COL_W - 16}>
              <span className="dkp-mono" style={{ fontSize: 9.3, letterSpacing: '.08em', color: '#6B6E75' }}>{termin}</span>
            </Abs>
            {b.items.map((it) => {
              const y = iy;
              iy += 21 + Math.max(0, it.lines - 1) * 16;
              return (
                <div key={it.ref}>
                  <Abs x={x + 16} y={y} w={68}>
                    <span className="dkp-mono" style={{ fontSize: 9.3, fontWeight: 700, color: '#C8A96E' }}>{it.ref}</span>
                  </Abs>
                  <Abs x={x + 88} y={y - 1} w={COL_W - 88}>
                    <div style={{ fontSize: 10.7, fontWeight: 500, color: '#3A3D42', lineHeight: 1.5 }}>{it.title}</div>
                  </Abs>
                </div>
              );
            })}
          </div>
        );
      })) : null}
      <Brand />
      <PageNo n={pageNo} />
    </Dkp>
  );
}
